import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageStatusEventQuickInfo extends Layout {
    sourceEvent: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
